import { createContext, ReactNode, useCallback, useContext, useState } from 'react'
import { useFormContext } from 'react-hook-form'
import { useIsManualMode } from '../../../../hooks'
import { AppointmentFormData } from '../../../../types'

interface UseTimeEntryContext {
  beManualMode: (isManualMode: boolean) => void
  isManualMode: boolean
}

interface TimeEntryModeProviderProps {
  children: ReactNode
}

const context = createContext({ isManualMode: false } as UseTimeEntryContext)
const { Provider } = context

const TimeEntryModeProvider = ({ children }: TimeEntryModeProviderProps) => {
  const { beManualMode: beParentManualMode } = useIsManualMode()
  const [isManualMode, beManualMode] = useState(false)
  const { setValue, clearErrors } = useFormContext<AppointmentFormData>()

  const beManualModeProxy = useCallback(
    (willBeManualMode: boolean) => {
      if (willBeManualMode) {
        setValue('clientStartTime', null)
      }

      clearErrors('clientStartTime')
      beManualMode(willBeManualMode)
      beParentManualMode(willBeManualMode)
    },
    [setValue, beManualMode]
  )

  const contextValue = {
    beManualMode: beManualModeProxy,
    isManualMode,
  }

  return <Provider value={contextValue}>{children}</Provider>
}

const useTimeEntryMode = () => useContext(context)

export { TimeEntryModeProvider, useTimeEntryMode }
